import { convertDateStringToDate } from './date';
const DEFAULT_LOCALE = navigator.language || 'en-EN';
export var FORMATS;
(function (FORMATS) {
    FORMATS["SHORT"] = "short";
    FORMATS["SHORT_WITH_WEEKDAY"] = "short_with_weekday";
    FORMATS["MEDIUM"] = "medium";
    FORMATS["LONG"] = "LONG";
})(FORMATS || (FORMATS = {}));
export var WEEKDAY_FORMATS;
(function (WEEKDAY_FORMATS) {
    WEEKDAY_FORMATS["LONG"] = "long";
    WEEKDAY_FORMATS["SHORT"] = "short";
    WEEKDAY_FORMATS["NARROW"] = "narrow";
})(WEEKDAY_FORMATS || (WEEKDAY_FORMATS = {}));
function checkLocaleValidity(locale) {
    try {
        Intl.NumberFormat(locale);
        return true;
        // eslint-disable-next-line no-unused-vars
    }
    catch (err) {
        // Incorrect locale information provided, try formatting it to ICU standards.
        return false;
    }
}
function getIcuLocale() {
    const { icuLocale } = document.documentElement.dataset;
    if (!icuLocale || !checkLocaleValidity(icuLocale)) {
        return DEFAULT_LOCALE;
    }
    return icuLocale;
}
function parseLongDate(date) {
    const dayName = date.toLocaleDateString(getIcuLocale(), { weekday: 'long' });
    const formattedDate = new Intl.DateTimeFormat(getIcuLocale(), {
        dateStyle: 'long'
    }).format(date);
    return `${dayName} ${formattedDate}`;
}
function parseShortDate(date) {
    const day = date.toLocaleDateString(getIcuLocale(), { weekday: 'short' });
    const formattedDate = new Intl.DateTimeFormat(getIcuLocale(), {
        day: '2-digit',
        month: 'short'
    }).format(date);
    return `${day} ${formattedDate}`;
}
export function intlDateFormat(dateTimeString, type) {
    const date = convertDateStringToDate(dateTimeString);
    switch (type) {
        case FORMATS.SHORT:
            return new Intl.DateTimeFormat(getIcuLocale(), {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            }).format(date);
        case FORMATS.SHORT_WITH_WEEKDAY:
            return parseShortDate(date);
        case FORMATS.MEDIUM:
            return new Intl.DateTimeFormat(getIcuLocale(), {
                dateStyle: 'long'
            }).format(date);
        case FORMATS.LONG:
            return parseLongDate(date);
        default:
            throw new Error(`${type} is an invalid format`);
    }
}
export function intlTimeFormat(dateTimeString) {
    const date = convertDateStringToDate(dateTimeString);
    return new Intl.DateTimeFormat(getIcuLocale(), {
        timeStyle: 'short'
    }).format(date);
}
export function intlDateTimeFormat(dateTime, type) {
    return `${intlDateFormat(dateTime, type)} ${intlTimeFormat(dateTime)}`;
}
export function intlDatePlaceholder() {
    try {
        const dateString = intlDateFormat('2222-11-22', FORMATS.SHORT);
        return dateString.replace('2222', 'yyyy').replace('22', 'dd').replace('11', 'mm');
        // eslint-disable-next-line no-unused-vars
    }
    catch (e) {
        return 'dd/mm/yyyy';
    }
}
export function intlWeekDay(date, weekdayFormat = WEEKDAY_FORMATS.SHORT) {
    return date.toLocaleDateString(getIcuLocale(), { weekday: weekdayFormat });
}
